<template>
  <div class="container">
    <el-row :gutter="10" class="header">
      <span>数据截止时间: {{ queryDate }}</span
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </el-row>
    <el-row :gutter="10">
      <el-input
        style="width: 150px"
        v-model="search"
        placeholder="快速搜索"
        size="mini"
      ></el-input>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-badge class="mark" :value="machineList.length">
        <el-tag type="primary" size="mini">机器总数</el-tag> </el-badge
      >&nbsp;&nbsp;&nbsp;&nbsp;
      <el-badge class="mark" :value="todayOnline.length">
        <el-tag type="success" size="mini">今天在线</el-tag>
      </el-badge>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button type="text" @click="getCurrentVersion" size="mini">刷新</el-button>
    </el-row>
    <el-row :gutter="10">
      <vvTable :data="machineListBySearch" :config="tableConfig" :height="700">
        <template slot-scope="scope" slot="canteen_slot">
          {{ scope.row.eatery_name + "--" + scope.row.canteen_name }}
        </template>
        <template slot-scope="scope" slot="canteen_slot">
          {{ scope.row.eatery_name + scope.row.canteen_name }}
        </template>
        <template slot-scope="scope" slot="client_slot">
          {{
            findVersion(scope.row, 1) ? findVersion(scope.row, 1).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="api_slot">
          {{
            findVersion(scope.row, 2) ? findVersion(scope.row, 2).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="food_slot">
          {{
            findVersion(scope.row, 3) ? findVersion(scope.row, 3).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="region_slot">
          {{
            findVersion(scope.row, 4) ? findVersion(scope.row, 4).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="dish_register_slot">
          {{
            findVersion(scope.row, 5) ? findVersion(scope.row, 5).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="dish_slot">
          {{
            findVersion(scope.row, 6) ? findVersion(scope.row, 6).version : "-"
          }}
        </template>
        <template slot-scope="scope" slot="date_slot">
          {{
            scope.row.last_update_ts
              ? tsTodatetime(scope.row.last_update_ts)
              : "-"
          }}
        </template>
        <template slot-scope="scope" slot="offline_slot">
          {{
            scope.row.offline_days || scope.row.offline_days === 0
              ? scope.row.offline_days
              : "无数据"
          }}
        </template>
        <template slot-scope="scope" slot="event_slot">
          <el-button type="text" size="mini" @click="viewDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </vvTable>
      <el-dialog title="机器详细信息" :visible.sync="detailShow" width="700">
        <el-table :data="currentDetail" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            prop="version_name" label="模块名称">
           <template slot-scope="scope">
              <span v-if="Number(scope.row.module_type) === 1">
              主客户端
            </span>
            <span v-if="Number(scope.row.module_type) === 2">
              识别莫模块
            </span>
            <span v-if="Number(scope.row.module_type) === 3">
              菜品模型
            </span>
            <span v-if="Number(scope.row.module_type) === 4">
              识别框模块
            </span>
            <span v-if="Number(scope.row.module_type) === 5">
              碗碟注册模型
            </span>
            <span v-if="Number(scope.row.module_type) === 6">
              碗碟模型
            </span>
           </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="version" label="版本号"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="version_desc" label="更新日志">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="更新时间"
          >
            <template slot-scope="scope">
              {{ tsTodatetime(scope.row.version_ts) }}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--<el-table-->
      <!--border-->
      <!--:data="machineListBySearch"-->
      <!--style="width: 100%"-->
      <!--:default-sort="{prop: 'offLineDays', order: 'ascending'}"-->
      <!--height="800px"-->
      <!--&gt;-->
      <!--<el-table-column header-align="center" align="center" prop="eatery_name" label="食堂"></el-table-column>-->
      <!--<el-table-column header-align="center" align="center" prop="canteen_name" label="餐厅"></el-table-column>-->
      <!--<el-table-column header-align="center" align="center" prop="machine_name" label="机器名字"></el-table-column>-->
      <!--<el-table-column header-align="center" align="center" prop="machine_id" label="机器id"></el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="上次使用时间">-->
      <!--<template-->
      <!--slot-scope="scope"-->
      <!--&gt;{{scope.row.last_used_ts === -1 ? '从未使用' : tsTodatetime(scope.row.last_used_ts)}}</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--header-align="center"-->
      <!--align="center"-->
      <!--label="离线时间(天)"-->
      <!--prop="offLineDays"-->
      <!--sortable-->
      <!--&gt;-->
      <!--<template slot-scope="scope">-->
      <!--<el-tag type="danger" v-if="scope.row.offLineDays === 9999">从未使用</el-tag>-->
      <!--<el-tag type="success" v-else-if="scope.row.offLineDays === 0">当天使用</el-tag>-->
      <!--<el-tag type="warning" v-else>离线{{scope.row.offLineDays}}天</el-tag>-->
      <!--</template>-->
      <!--</el-table-column>-->
      <!--&lt;!&ndash;<el-table-column&ndash;&gt;-->
      <!--&lt;!&ndash;header-align="center"&ndash;&gt;-->
      <!--&lt;!&ndash;align="center"&ndash;&gt;-->
      <!--&lt;!&ndash;label="状态"&ndash;&gt;-->
      <!--&lt;!&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;<template slot-scope="scope">&ndash;&gt;-->
      <!--&lt;!&ndash;<el-tag type="error" v-if="scope.row.offLineDays === 9999">从未使用</el-tag>&ndash;&gt;-->
      <!--&lt;!&ndash;<el-tag type="success" v-else-if="scope.row.offLineDays === 0">当天在线</el-tag>&ndash;&gt;-->
      <!--&lt;!&ndash;<el-tag type="error" v-else-if="scope.row.offLineDays > 0 && scope.row.offLineDays < 7">本周使用过</el-tag>&ndash;&gt;-->
      <!--&lt;!&ndash;<el-tag type="warning" v-else-if="scope.row.offLineDays > 6 && scope.row.offLineDays < 9999">长期未使用&ndash;&gt;-->
      <!--&lt;!&ndash;</el-tag>&ndash;&gt;-->
      <!--&lt;!&ndash;</template>&ndash;&gt;-->
      <!--&lt;!&ndash;</el-table-column>&ndash;&gt;-->
      <!--</el-table>-->
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import vvTable from 'vue-virtual-table';
import moment from 'moment';
import {apiGetCurrentVersionList} from '@/api';
import pinyinMatch from 'pinyin-match';

export default {
  name: "machineAdmin",
  components: {
    // filterWrapper
    vvTable
  },
  data() {
    return {
      currentMachine: {},
      detailShow: false,
      search: "",
      queryDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
      versionList: [],
      type_array: ["主客户端", "识别模块", "菜品模型", "识别框模块", "碗碟模型"]
    };
  },
  mounted() {
    this.toggleSubMenu(false);
    this.setSubTitle("机器状态查看");
    this.getCurrentVersion();
    this.filter();
  },
  methods: {
    ...mapMutations([
      "setSubTitle",
      "emitLoading",
      "removeLoading",
      "toggleSubMenu"
    ]),
    findDetail(row) {
      // const list = this.versionList;
      const { machine_uuid } = row;
      // const res = this.$_.find(list, (a) => Number(a.machine_uuid) === Number(machine_uuid));
      // return res;

      if (this.versionList.hasOwnProperty(machine_uuid)) {
        return this.versionList[row.machine_uuid];
      } else {
        return null;
      }
    },
    viewDetail(row) {
      this.currentMachine = row;
      this.detailShow = true;
    },
    findVersion(row, type) {
      const { version_info_list } = row;
      if (version_info_list && version_info_list.length > 0) {
        let res = this.$_.find(
          version_info_list,
          a => Number(a.module_type) === type
        );
        console.log(res);
        return res;
      } else {
        return {
          version: "-",
          version_ts: "-"
        };
      }
    },
    async getCurrentVersion() {
      this.emitLoading();
      try {
        this.queryDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        const res = await apiGetCurrentVersionList();
        this.versionList = res.machine_info_dic;
        this.removeLoading();
      } catch (e) {
        this.removeLoading();
        this.$message.error('获取版本状态失败');
      }
      let machineList = this.allMachineList;
    },
    tsTodatetime(ts) {
      if (ts) {
        return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
      } else {
        return '暂无时间';
      }
    },
    filter() {
      setTimeout(() => {
        this.filter();
      }, 30 * 60 * 1000);
    },
    offLineDays(ts) {
      if (ts) {
        console.log(ts);
        return Math.floor(
          (new Date().getTime() - ts * 1000) / 3600 / 24 / 1000
        );
      }
    }
  },
  filters: {},
  computed: {
    ...mapGetters(["allMachineList"]),
    currentDetail() {
      if (this.currentMachine.hasOwnProperty("version_info_list")) {
        return this.currentMachine.version_info_list;
      } else {
        return [];
      }
    },
    machineList() {
      let list = this.$_.cloneDeep(this.allMachineList);
      const versionList = this.versionList;
      list.forEach(a => {
        const { machine_uuid } = a;
        if (versionList.hasOwnProperty(machine_uuid)) {
          let detail = versionList[machine_uuid];
          console.log(detail);
          const { last_update_ts, version_info_list } = detail;
          this.$set(a, "version_info_list", version_info_list);
          this.$set(a, "last_update_ts", last_update_ts);
          this.$set(a, "offline_days", this.offLineDays(last_update_ts));
        }
      });
      // return list.filter(a => a.hasOwnProperty('version_info_list'));
      list = this.$_.orderBy(list, "last_update_ts", "asc");
      return list;
    },
    tableConfig() {
      return [
        {
          prop: "_action",
          name: "餐厅名称",
          actionName: "canteen_slot",
          width: 200
        },
        { prop: "machine_id", name: "机器ID" },
        { prop: "_action", name: "碗碟模型", actionName: "dish_slot" },
        { prop: "_action", name: "识别框模块", actionName: "region_slot" },
        { prop: "_action", name: "菜品模型", actionName: "food_slot" },
        { prop: "_action", name: "识别模块", actionName: "api_slot" },
        { prop: "_action", name: "主客户端", actionName: "client_slot" },
        {
          prop: "_action",
          name: "上次在线",
          actionName: "date_slot",
          width: 200
        },
        { prop: "_action", name: "离线时间", actionName: "offline_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ];
    },
    userinfo() {
      return this.$store.getters.userinfo();
    },
    todayOnline() {
      return this.machineList.filter(a => {
        return a.offline_days === 0;
      });
    },
    machineListBySearch() {
      let seachText = this.search;
      if (!seachText) {
        return this.machineList;
      } else {
        return this.machineList.filter(a => {
          let text =
            a.canteen_name + "," + a.eatery_name + "," + a.machine_name;
          let res = pinyinMatch.match(text, seachText);
          return res.length > 0;
        });
      }
    },
    machineIdList() {
      return this.machineList.map(a => {
        return a.machine_id;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    margin: 5px 0;
    top: -35px;
  }
  .header-title {
    display: inline-block;
  }
}
</style>
